package horcrux.frontend.common.views.auth

import horcrux.common.api.dtos.types.EmailAddress
import horcrux.frontend.common.BooleanState
import horcrux.frontend.common.GlobalAppState
import mui.material.AlertColor
import mui.material.Dialog
import react.FC
import react.Props
import react.useEffect

external interface AuthDialogProps : Props {
    var globalAppState: GlobalAppState
}

val AuthDialog = FC<AuthDialogProps> { props ->
    val isLoggedInState = BooleanState(true)
    useEffect(props.globalAppState.isLoggedIn) {
        props.globalAppState.submitAuthenticationClientAPIRequest { authenticationClient ->
            val user = authenticationClient.getUser().onLeft {
                isLoggedInState.setFalse()
            }.bind()
            user.email?.let {
                props.globalAppState.emailAddressMaybeState.set(EmailAddress(it))
                isLoggedInState.setTrue()
            } ?: run {
                props.globalAppState.emailAddressMaybeState.reset()
                props.globalAppState.updateBanner(
                    AlertColor.info,
                    "Sorry there was an an unexpected error when trying to find your email address"
                )
            }
        }
    }
    Dialog {
        this.open = !isLoggedInState.get()
        AuthContainer {
            this.globalAppState = props.globalAppState
        }
    }
}
